import { Route } from '@lumapps/router';
import { AppId, URL_PREFIX } from '@lumapps/router/constants';

export const designerContentEditionRoute: Route = {
    appId: AppId.designer,
    path: `/${URL_PREFIX}/designer/content/edit/:id`,
};

export const designerContentEdition = (contentId: string): Route => ({
    ...designerContentEditionRoute,
    params: { id: contentId },
});

export const designerContentCreationRoute: Route = {
    appId: AppId.designer,
    path: `/${URL_PREFIX}/designer/content/create/:contentTypeId/:templateId?`,
};

export const designerContentCreation = (contentTypeId: string, templateId?: string): Route => ({
    ...designerContentCreationRoute,
    params: { contentTypeId, templateId },
});
